var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.94 25.34a22.45 22.45 0 0 0 0 44.88h1v-17.79c0-1.33 1-3 2.35-3h19c0-.74.07-1.25.07-1.65a22.52 22.52 0 0 0 -22.42-22.44zm17.91 20.52h-5.78a33.5 33.5 0 0 0 -3.17-13.46 18.16 18.16 0 0 1 8.95 13.46zm-20.48-14.75v14.75h-5.13c.39-7.03 2.61-12.59 5.13-14.75zm0 18.59v14.74c-2.5-2.17-4.74-7.7-5.13-14.74zm5.13-3.84v-14.75c2.5 2.16 4.76 7.72 5.13 14.75zm-11.5-13.46a34.57 34.57 0 0 0 -3.2 13.46h-5.8a18.11 18.11 0 0 1 9-13.46zm-9 17.94h5.81a33.55 33.55 0 0 0 3.19 13.42 18.11 18.11 0 0 1 -9-13.42z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.89 53.2h-27.23a3.13 3.13 0 0 0 -3.13 3.13v15.2a3.13 3.13 0 0 0 3.13 3.13h27.23a3.13 3.13 0 0 0 3.11-3.13v-15.2a3.13 3.13 0 0 0 -3.11-3.13zm-23.57 18.33a3.65 3.65 0 0 0 -3.55-3.75h-.1v-7.78a3.65 3.65 0 0 0 3.75-3.55v-.05-.09h19.78a3.65 3.65 0 0 0 3.59 3.69h.1v7.82a3.66 3.66 0 0 0 -3.75 3.58v.11z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.27,
    cy: 63.66,
    r: 5.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherPayment);
export default __webpack_public_path__ + "static/media/other-payment.7e5ce53eab9107e9c6462bf5b57e481b.svg";
export { ForwardRef as ReactComponent };